function nodes() {
 return this.regions().selectAll(this.nodeName());
}

export default nodes;


// WEBPACK FOOTER //
// ./layouts/default/nodes.js